import { render, staticRenderFns } from "./SectionScholarship.component.vue?vue&type=template&id=b0faf06e&"
import script from "./SectionScholarship.component.vue?vue&type=script&lang=js&"
export * from "./SectionScholarship.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports